/**
 * Enum defining standard WebSocket event types
 */
export enum WebSocketEventType {
	// Server connection events
	NewMessage = 'newMessage',
	EditMessage = 'editMessage',
	DeleteMessage = 'deleteMessage',

	// Custom events can be added here
}

/**
 * Interface for WebSocket message structure
 */
export interface WebSocketMessage {
	messageType: WebSocketEventType | string;
	payload: any;
}

/**
 * Parse a WebSocket message
 * @param event The MessageEvent received from WebSocket
 * @returns Parsed WebSocketMessage object
 */
export const parseWebSocketMessage = (event: MessageEvent): WebSocketMessage => {
	const data = JSON.parse(event.data);
	console.log('data:', data);
	return {
		messageType: data.messageType,
		payload: data.payload,
	};
};

/**
 * Create a formatted WebSocket message
 * @param type The message type
 * @param payload The message payload
 * @returns Formatted WebSocketMessage object
 */
export const createWebSocketMessage = (
	type: WebSocketEventType | string,
	payload: any
): WebSocketMessage => {
	return {
		messageType: type,
		payload,
	};
};

/**
 * Helper to create event handlers for specific WebSocket events
 * @param eventType The event type to listen for
 * @param callback The callback function to execute when event is received
 * @returns A function to handle WebSocket messages
 */
export const createEventHandler = (
	eventType: WebSocketEventType | string,
	callback: (payload: any) => void
) => {
	return (message: WebSocketMessage) => {
		if (message.messageType === eventType) {
			callback(message.payload);
		}
	};
};
